<div class="filter filter-padded-left" [class.disabled]="!flask.show">
  <span class="filter-body">
    <div class="filter-title filter-label table-checkbox-group"
      [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'flasks-my-regular-magic/' + equipmentType + '/' + (equipmentIndex + 1) : null"
      (click)="onHighlightClick($event)"
      (mouseenter)="onHighlightMouseEnter($event)"
      (mouseleave)="onHighlightMouseLeave($event)">
      <span class="input-group-btn">
        <button class="btn toggle-btn"
          [class.off]="flask.highlightConfig.regularMagic === false"
          [disabled]="!flask.show"
          (click)="toggleRegularMagic()"></button>
      </span>
      <div class="table-checkbox-label">
        <span class="filter-title-text">Magic {{ flask.flaskClass === 'Charms' ? 'Charms' : 'Flasks' }}</span>

        <div class="filter-tip">
          <p>
            Show regular <span class="magic-item-color">Magic</span> {{ flask.flaskClass === 'Charms' ? 'Charms' : 'Flasks' }} of your chosen type(s).
            <br /><br />Disable if you're only interested in special versions of these items, specified below.
          </p>
        </div>

        @if (!isMobile()) {
          <app-equipment-tier-picker
            [equipmentType]="EquipmentType.MyFlasksRegularMagic"
            [active]="flask.highlightConfig.regularMagic"
            exampleName="{{ getExampleGearName() }}"
            [rarity]="Rarity.Magic"></app-equipment-tier-picker>
        }
      </div>
    </div>

    @if (flask.rarity === Rarity.Normal) {
      <span class="sep"></span>

      <div class="filter-title filter-label table-checkbox-group"
        [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'flasks-my-regular-normal/' + equipmentType + '/' + (equipmentIndex + 1) : null"
        (click)="onHighlightClick($event)"
        (mouseenter)="onHighlightMouseEnter($event)"
        (mouseleave)="onHighlightMouseLeave($event)">
        <span class="input-group-btn">
          <button class="btn toggle-btn"
            [class.off]="flask.highlightConfig.regularNormal === false"
            [disabled]="!flask.show"
            (click)="toggleRegularNormal()"></button>
        </span>
        <div class="table-checkbox-label">
          <span class="filter-title-text">Normal {{ flask.flaskClass === 'Charms' ? 'Charms' : 'Flasks' }}</span>

          <div class="filter-tip">
            <p>
              Show regular <span class="normal-item-color">Normal</span> {{ flask.flaskClass === 'Charms' ? 'Charms' : 'Flasks' }} of your chosen type(s).
              <br /><br />Disable if you're only interested in special versions of these items, specified below.
            </p>
          </div>

          @if (!isMobile()) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.MyFlasksRegularNormal"
              [active]="flask.highlightConfig.regularNormal"
              exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
          }
        </div>
      </div>
    }

    <span class="spacer" style="display: table-cell; width: 100%;"></span>
  </span>
</div>

<div class="filter filter-padded-left" [class.disabled]="!flask.show">
  <span class="filter-body">
    <div class="filter-title filter-label table-checkbox-group"
      [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'flasks-my-quality/' + equipmentType + '/' + (equipmentIndex + 1) : null"
      (click)="onHighlightClick($event)"
      (mouseenter)="onHighlightMouseEnter($event)"
      (mouseleave)="onHighlightMouseLeave($event)">
      <span class="input-group-btn">
        <button class="btn toggle-btn"
          [class.off]="flask.highlightConfig.quality === false"
          [disabled]="!flask.show"
          (click)="toggleQuality()"></button>
      </span>
      <div class="table-checkbox-label">
        <span class="filter-title-text">Quality {{ flask.flaskClass === 'Charms' ? 'Charms' : 'Flasks' }}</span>

        <div class="filter-tip">
          <p>
            Show {{ flask.flaskClass === 'Charms' ? 'Charms' : 'Flasks' }} of your chosen type(s) with at least the specified Quality.
            <br /><br />Disabling these options will <i>not</i> hide these items, but cause them to just be shown, not highlighted; unless you also disable the 'Normal' and 'Magic' {{ flask.flaskClass === 'Charms' ? 'Charms' : 'Flasks' }} options above.
          </p>
        </div>

        @if (flask.highlightConfig.quality && !isMobile()) {
          <app-equipment-tier-picker
            [equipmentType]="EquipmentType.MyFlasksQuality"
            [active]="flask.highlightConfig.quality"
            exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
        }

      </div>
    </div>

    <span class="sep"></span>

    <input type="number" placeholder="min" maxlength="3" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [disabled]="!flask.show || flask.highlightConfig.quality === false"
      [(ngModel)]="flask.highlightConfig.qualityMin" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

    <span class="sep"></span>

    <div class="filter-title filter-label table-checkbox-group"
      [attr.data-filter-rule-id]="equipmentType && equipmentIndex !== undefined ? 'flasks-my-ilevel/' + equipmentType + '/' + (equipmentIndex + 1) : null"
      (click)="onHighlightClick($event)"
      (mouseenter)="onHighlightMouseEnter($event)"
      (mouseleave)="onHighlightMouseLeave($event)">
      <span class="input-group-btn">
        <button class="btn toggle-btn"
          [class.off]="flask.highlightConfig.iLevel === false"
          [disabled]="!flask.show"
          (click)="toggleILevel()"></button>
      </span>
      <div class="table-checkbox-label">
        <span class="filter-title-text">iLevel Crafting {{ isMobile() ? '' : 'Bases' }}</span>

        <div class="filter-tip">
          <p>
            Additionally show and/or highlight <span class="normal-item-color">Normal</span> {{ flask.flaskClass === 'Charms' ? 'Charms' : 'Flasks' }} of your chosen type(s) (ignoring your chosen minimum Rarity) with at least the specified Item Level. Items with higher Item Levels can contain the highest level mods, and are thus good candidates to craft on.
            <br /><br />If you disable these options, these items will not be shown unless specified by other rules.
          </p>
        </div>

        @if (flask.highlightConfig.iLevel && !isMobile()) {
          <app-equipment-tier-picker
            [equipmentType]="EquipmentType.MyFlasksILevel"
            [active]="flask.highlightConfig.iLevel"
            exampleName="{{ getExampleGearName() }}"></app-equipment-tier-picker>
        }

      </div>
    </div>

    <span class="sep"></span>

    <input type="number" placeholder="min" maxlength="3" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax"
      [disabled]="!flask.show || flask.highlightConfig.iLevel === false"
      [(ngModel)]="flask.highlightConfig.iLevelMin" (change)="updateFilter()" style="min-width: 40px; width: 40px;">

    <span class="spacer" style="display: table-cell; width: 100%;"></span>
  </span>
</div>

<div class="filter filter-padded-left" [class.disabled]="!flask.show">
  <span class="filter-body">
    <div class="filter-title filter-label table-checkbox-group">
      <span class="input-group-btn">
        <button class="btn toggle-btn"
          [class.off]="toggleAllState === false"
          [disabled]="!flask.show"
          (click)="toggleAll()"></button>
      </span>
      <div class="table-checkbox-label">
        <span class="filter-title-text">Toggle All</span>
      </div>
    </div>
  </span>
</div>
